import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isAuthenticated, logout } from './services/authService';
import { NotificationProvider } from './utils/NotificationContext';
import Sidebar from './components/Sidebar';
import { RefreshProvider } from './utils/RefreshContext';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import DeleteAccount from './pages/DeleteAccount';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import ManageUser from './pages/ManageUser';
import AirportManagement from './pages/AirportManagement';
import POIManagement from './pages/POIManagement';
import Airlines from './pages/Airlines';
import RoutesPage from './pages/Routes';
import FlightOperations from './pages/FlightOperations';
import FlightAlerts from './pages/FlightAlerts';
import AirportSyncLogs from './pages/AirportSyncLogs';
import FlightDetails from './pages/FlightDetails';
import SecurityLanes from './pages/SecurityLanes';
import SecurityLane from './pages/SecurityLane';
import GateManagement from './pages/GateManagement';
import PickupZones from './pages/PickupZones';
import Settings from './pages/Settings';
import Categories from './pages/Categories';
import DynamicFields from './pages/DynamicFields';
import Notifications from './pages/Notifications';
import ImageApproval from './pages/ImageApproval';
import './styles/globals.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsLoggedIn(false);
      setSidebarOpen(false);
    }
  };

  return (
    <BrowserRouter>
      <RefreshProvider>
        <NotificationProvider>
          <ToastContainer theme="dark" position="top-right" />

          {!isLoggedIn ? (
            <Routes>
              <Route path="/" element={<Login onLogin={() => setIsLoggedIn(isAuthenticated())} />} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          ) : (
            <div className="layout">
              {sidebarOpen && (
                <div onClick={() => setSidebarOpen(false)} className="mobile-overlay" />
              )}
              <div className="mobile-topbar">
                <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8 }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
                  </svg>
                </button>
                <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 18, fontWeight: 700, color: 'white' }}>
                  Gate<span style={{ color: 'var(--gold)' }}>Guide</span>
                </div>
                <div style={{ width: 38 }} />
              </div>
              <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onLogout={handleLogout} />
              <main className="main">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/dynamic-fields" element={<DynamicFields />} />
                  <Route path="/users/create" element={<ManageUser />} />
                  <Route path="/users/edit/:id" element={<ManageUser />} />
                  <Route path="/airports" element={<AirportManagement />} />
                  <Route path="/pois" element={<POIManagement />} />
                  <Route path="/airlines" element={<Airlines />} />
                  <Route path="/routes" element={<RoutesPage />} />
                  <Route path="/flights" element={<FlightOperations />} />
                  <Route path="/flights/:id" element={<FlightDetails />} />
                  <Route path="/flight-alerts" element={<FlightAlerts />} />
                  <Route path="/sync-logs" element={<AirportSyncLogs />} />
                  <Route path="/security-lanes" element={<SecurityLane />} />
                  <Route path="/security-checkpoints" element={<SecurityLanes />} />
                  <Route path="/gates" element={<GateManagement />} />
                  <Route path="/pickup-zones" element={<PickupZones />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/images" element={<ImageApproval />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </main>
            </div>
          )}
        </NotificationProvider>
      </RefreshProvider>
    </BrowserRouter>
  );
}

export default App;
